import script from "./FormDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./FormDropdown.vue?vue&type=style&index=0&id=575b9ce0&lang=scss"

const __exports__ = script;

export default __exports__